<template>
  <div id="app" >
	<vue-headful
        title="BONUS FACILE"
        description="Incentivi fiscali. Ci pensiamo noi. Offri ai tuoi clienti sconti immediati direttamente in fattura. Noi gestiamo tutta la parte burocratica"
    />
    <div class="main">

			<navigation/>

			<div class="main-container">

				<router-view/>

			</div>

	</div>

    <sqreen-footer/>

  </div>

</template>

<style lang="css" scoped>

  @import'~bootstrap/dist/css/bootstrap.min.css';
  @import './assets/css/main.css';


</style>

<script>
import Navigation from 'components/navigation'
import { USER_REQUEST } from 'actions/user'
import SqreenFooter from './components/footer/index.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    SqreenFooter,
    Navigation,
	//loading,
	},
  name: 'app',
  data () {
      return {
		fullscreen: false,
	  }
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
  },
  watch:{
	isAuthenticated: function(){
		this.$store.dispatch(USER_REQUEST)
	}
  },
  mounted: function () {
    if (this.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST)
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue